import { SCREEN_IDS } from "./global-enums";
import {
  adminPath,
  brandAdminPath,
  groupAdminPath,
  managerAdminPath,
  viewPathConstants,
} from "../constants/global.constants";
import { customerSurveyUrl } from "../views/shared-screens/constants";

import AdminRoutes from "../views/admin-screens/adminRoutes";
import BrandRoutes from "../views/brand-screens/brandRoutes";
import GroupRoutes from "../views/group-screens/groupRoutes";
import ManagerRoutes from "../views/manager-screens/managerRoutes";

import ResetPassword from "../views/login/resetPassword";
import EmailVerification from "../views/emailVerification/emailVerification";
import ChangeSurveyPreferences from "../views/shared-screens/views/changeSurveyPreferences/changeSurveyPreferences";

import PreviewSurvey from "../views/shared-screens/views/previewSurvey/previewSurvey";
import CustomerSurvey from "../views/shared-screens/views/customerSurvey/customerSurvey";
import SurveyQuestions from "../views/shared-screens/views/surveyQuestions/surveyQuestions";
import Inbox from "../views/shared-screens/views/inbox/inbox";
import Dashboard from "../views/shared-screens/views/dashboard/dashboard";
import MarketingAttributionReport from "../views/shared-screens/views/marketingAttributionReport/marketingAttributionReport";
import RouteFromFR from "../shared/components/navigationComponent/routeFromFR";
import processedMarketingAttributionReport from "../views/shared-screens/views/processedMarketingAttributionReport/processedMarketingAttributionReport";
import FromSurveyFeedbackToInbox from "../shared/components/navigationComponent/fromSurveyFeedbackToInbox";
import Unauthorized from "../views/shared-screens/views/unauthorized/unauthorized";

const routes = [
  {
    path: viewPathConstants.UNAUTHORIZED,
    name: "unauthorized",
    screenId: SCREEN_IDS.GENERIC,
    component: Unauthorized,
    displayName: "Unauthorized",
  },
  {
    path: viewPathConstants.REDIRECTING_TO_STORE_PROFILE,
    name: "redirecting-to-store-profile",
    screenId: SCREEN_IDS.GENERIC,
    component: RouteFromFR,
    displayName: "Redirecting To Store Profile",
  },
  {
    path: viewPathConstants.REDIRECTING_TO_DEFAULT_SCREEN,
    name: "redirecting-to-default-screen",
    screenId: SCREEN_IDS.GENERIC,
    component: FromSurveyFeedbackToInbox,
    displayName: "Redirecting To Default Screen",
  },
  {
    path: viewPathConstants.CONFIRM_PASSWORD,
    name: "reset-password",
    screenId: SCREEN_IDS.GENERIC,
    component: ResetPassword,
    displayName: "Reset Password",
  },
  {
    path: viewPathConstants.EMAIL_VERIFICATION,
    name: "email-verification",
    screenId: SCREEN_IDS.GENERIC,
    component: EmailVerification,
    displayName: "Email Verification",
  },
  {
    path: viewPathConstants.CHANGE_SURVEY_PREFERENCES,
    name: "change-survey-preferences",
    screenId: SCREEN_IDS.GENERIC,
    component: ChangeSurveyPreferences,
    displayName: "Change Survey Preferences",
  },
  {
    path: `${customerSurveyUrl + viewPathConstants.CUSTOMER_SURVEY}`,
    name: "customer-survey",
    component: CustomerSurvey,
    displayName: "Customer Survey",
  },
  {
    path: viewPathConstants.PREVIEW_SURVEY,
    name: "preview-survey",
    component: PreviewSurvey,
    displayName: "Preview Survey",
  },
  {
    path: adminPath.MARKETING_ATTRIBUTION,
    name: "marketing-attribution",
    screenId: SCREEN_IDS.BRANDS,
    component: MarketingAttributionReport,
    displayName: "Marketing Attribution",
    breadcrumb: "Marketing Attribution",
  },
  {
    path: viewPathConstants.INBOX,
    screenId: SCREEN_IDS.BRANDS,
    name: "inbox",
    component: Inbox,
    displayName: "Messages",
    breadcrumb: "Inbox",
  },
  // Super admin routes
  ...AdminRoutes,
  {
    path: adminPath.RESTAURANTS_BRAND_SURVEY_QUESTIONS,
    name: "survey-creation",
    screenId: SCREEN_IDS.BRANDS,
    component: SurveyQuestions,
    displayName: "Survey Questions",
    breadcrumb: "Brand Survey Questions",
  },

  // Brand admin routes
  ...BrandRoutes,
  {
    path: adminPath.DASHBOARD,
    name: "dashboard",
    screenId: SCREEN_IDS.BRANDS,
    component: Dashboard,
    displayName: "Dashboard",
    breadcrumb: "Dashboard",
  },
  {
    path: adminPath.PROCESSED_MARKETING_ATTRIBUTION,
    name: "processed-marketing-attribution",
    screenId: SCREEN_IDS.BRANDS,
    component: processedMarketingAttributionReport,
    displayName: "Processed Marketing Attribution",
    breadcrumb: "Processed Marketing Attribution",
  },
  {
    path: brandAdminPath.BRAND_SERVEY_QUESTIONS,
    name: "survey-creation",
    screenId: SCREEN_IDS.BRANDS,
    component: SurveyQuestions,
    displayName: "Survey Questions",
    breadcrumb: "Brand Survey Questions",
  },

  // Group admin routes
  ...GroupRoutes,
  {
    path: groupAdminPath.GROUP_SURVEY_QUESTIONS,
    name: "survey-creation",
    screenId: SCREEN_IDS.BRANDS,
    component: SurveyQuestions,
    displayName: "Survey Questions",
    breadcrumb: "Group Survey Questions",
  },

  // Manager admin routes
  ...ManagerRoutes,
  {
    path: managerAdminPath.MANAGER_SERVEY_QUESTIONS,
    name: "survey-creation",
    screenId: SCREEN_IDS.BRANDS,
    component: SurveyQuestions,
    displayName: "Survey Questions",
    breadcrumb: "Manager Survey Questions",
  },
];

export default routes;
